import React, { useState } from "react";

const FeatureImpactDetails = ({ passive }) => {
  const [isOpen, setIsOpen] = useState(false);
  const impact = passive.impact;
  const contentId = `feature-impact-${passive.id}`;

  return (
    <div className="feature-impact-disclosure">
      <button
        aria-controls={contentId}
        aria-expanded={isOpen}
        className="feature-impact-trigger"
        type="button"
        onClick={() => setIsOpen((current) => !current)}
      >
        {impact.label}
      </button>
      {isOpen && (
        <div className="feature-impact-content" id={contentId}>
          <p><strong>{impact.descriptionLabel}:</strong> {impact.description}</p>
          <p><strong>{impact.sourceLabel}:</strong> {impact.source}</p>
          {impact.effects.map((effect, index) => (
            <dl className="feature-impact-effect" key={`${passive.id}:effect:${index}`}>
              <div><dt>{impact.targetLabel}</dt><dd>{effect.target}</dd></div>
              <div><dt>{impact.amountLabel}</dt><dd>{effect.amount}</dd></div>
              <div><dt>{impact.typeLabel}</dt><dd>{effect.bonusType}</dd></div>
              <div><dt>{impact.conditionLabel}</dt><dd>{effect.condition}</dd></div>
              <div><dt>{impact.statusLabel}</dt><dd><span className={`feature-impact-status is-${effect.statusKind}`}>{effect.status}</span></dd></div>
            </dl>
          ))}
        </div>
      )}
    </div>
  );
};

const PassivesSkillBox = ({
  generatedPassives = [],
  passives,
  header,
  onAddClick,
  onEditClick,
  onRemoveClick,
  onRuleChoice = () => {},
}) => {
  return (
    <div className="passive-skills">
      <div className="character-passive-skills">
          <div className="skills-header">
              <h2>{header}</h2>
              <button className="add-skill-button" type="button" onClick={onAddClick}>+</button>
          </div>
        {generatedPassives.map((passive) => (
          <div className="passive generated-feature" key={passive.id}>
            <div className="passive-name">
              {passive.referenceUrl ? <a href={passive.referenceUrl} target="_blank" rel="noreferrer">{passive.name}</a> : passive.name}
            </div>
            <div className="passive-description">
              {passive.description}
              {passive.choices.length > 0 && (() => {
                const hasOnlyCheckboxChoices = passive.choices.every((choice) => !choice.options.length);
                const renderChoices = () => (hasOnlyCheckboxChoices ? (
                  <div className="rule-choices-list">
                    {passive.choices.map((choice) => (
                      <label className="rule-choice" key={choice.id}>
                        <span>{choice.label}</span>
                        <input
                          checked={Boolean(choice.used)}
                          type="checkbox"
                          onChange={(event) => onRuleChoice(choice.id, { used: event.target.checked })}
                        />
                      </label>
                    ))}
                  </div>
                ) : (
                  <div className="rule-choices-list">
                    {passive.choices.map((choice) => (
                      <label className="rule-choice" key={choice.id}>
                        <span>{choice.label}</span>
                        <select value={choice.selectedValue || ""} onChange={(event) => onRuleChoice(choice.id, { selectedValue: event.target.value })}>
                          <option value="">{choice.placeholder}</option>
                          {choice.options.map((option) => {
                            const blocksDuplicateSelection = choice.type !== "ability";
                            const selectedByAnotherChoice = blocksDuplicateSelection && passive.choices.some((otherChoice) =>
                              otherChoice.id !== choice.id && otherChoice.selectedValue && otherChoice.selectedValue === option.value
                            );

                            return (
                              <option
                                key={option.value}
                                value={option.value}
                                disabled={selectedByAnotherChoice || option.disabled}
                                title={selectedByAnotherChoice ? "Already selected in another choice." : option.disabledReason}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </select>
                      </label>
                    ))}
                  </div>
                ));

                if (passive.choices.length === 1) return renderChoices();

                return (
                  <details className="rule-choices-disclosure">
                    <summary>{passive.choicesSummary}</summary>
                    {renderChoices()}
                  </details>
                );
              })()}
              {passive.impact && <FeatureImpactDetails passive={passive} />}
            </div>
            <span className="generated-feature-source">{passive.source}</span>
          </div>
        ))}
        {passives.map((passive) => (
          <div key={passive.id} className="passive" onClick={() => onEditClick(passive)}>
            <div className="passive-name">
              {passive.referenceUrl ? <a href={passive.referenceUrl} target="_blank" rel="noreferrer" onClick={(event) => event.stopPropagation()}>{passive.name}</a> : passive.name}
            </div>
            <div className="passive-description">{passive.description}</div>
            <button
              aria-label={`Remove ${passive.name || "passive"}`}
              className="remove-feat-button"
              title="Remove"
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                onRemoveClick(passive.id);
              }}
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
export default PassivesSkillBox;
